document.addEventListener('DOMContentLoaded',function(){
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t=document.querySelector('.menu-toggle'),n=document.querySelector('.site-header__nav');
  if(t&&n){t.addEventListener('click',function(){n.classList.toggle('is-open')})}
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var target=new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(target))return;
    function pad(x){return String(x).padStart(2,'0')}
    function tick(){
      var d=target-Date.now();
      if(d<=0){var live=el.getAttribute('data-live-text')||'LIVE';el.innerHTML='<div class="countdown__num">'+live+'</div>';return}
      var days=Math.floor(d/864e5),h=Math.floor(d%864e5/36e5),m=Math.floor(d%36e5/6e4),s=Math.floor(d%6e4/1e3);
      var q=function(sel){return el.querySelector(sel)};
      if(q('[data-cd-d]')){q('[data-cd-d]').textContent=pad(days);q('[data-cd-h]').textContent=pad(h);q('[data-cd-m]').textContent=pad(m);q('[data-cd-s]').textContent=pad(s);}
      setTimeout(tick,250);
    }
    tick();
  });
  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var main=document.querySelector('[data-main-image]');
      if(main){main.src=b.getAttribute('data-thumb');}
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');
    });
  });
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  }else{
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in')});
  }
  var tilt=document.querySelector('[data-tilt]');
  if(tilt && !reduced && window.matchMedia('(pointer:fine)').matches){
    var wrap=tilt.closest('.hero')||document.body;
    wrap.addEventListener('mousemove',function(e){
      var r=tilt.getBoundingClientRect();
      var x=(e.clientX-r.left-r.width/2)/r.width, y=(e.clientY-r.top-r.height/2)/r.height;
      tilt.style.transform='perspective(900px) rotateY('+(x*7)+'deg) rotateX('+(-y*7)+'deg)';
    });
    wrap.addEventListener('mouseleave',function(){tilt.style.transform='perspective(900px) rotateY(0) rotateX(0)'});
  }
  document.querySelectorAll('.qty-wrap').forEach(function(w){
    var inp=w.querySelector('input');
    w.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(ev){ev.preventDefault();
        var v=parseInt(inp.value||'0',10)+(b.dataset.dir==='up'?1:-1);
        inp.value=Math.max(0,v);
      });
    });
  });
});
